import React, { useState } from 'react';
import {
  withApi,
  withNotification,
} from 'wrappers';
import {
  Menu,
  useMediaQuery,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { messages } from 'constantes';
import Estados from 'constantes/Estados';
import { withStyles } from '@material-ui/core/styles';
import MenuItemBase from 'components/Controls/MenuItemBase';
import ButtonEstados from 'components/Controls/ButtonEstados';
import FormComentario from './FormComentario';

function EstadoSelection({
  id,
  doPut,
  appInfo,
  history,
  getResp,
  refresh,
  endPoint,
  checkAccess,
  estadoActual,
  genericException,
  redirect = false,
  redirectUrl = '',
  disabled = false, specificList = [],
  openOwnChangeModal,
  requiredPermissions,
  extraFunction = null,
  ownResponseCode = false,
  ...rest
}) {
  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const [estado, setEstado] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const isSmallView = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  let list;

  switch (estadoActual) {
    case Estados.APROBADO:
      list = [
        { label: Estados.NO_APROBADO },
      ];
      break;
    case Estados.NO_APROBADO:
      list = [
        { label: Estados.APROBADO },
      ];
      break;
    case Estados.PENDIENTE:
      list = [
        {
          label: Estados.APROBADO,
        },
        /*
        {
          label: Estados.PUBLICADO,
        },
        {
          label: Estados.NO_PUBLICADO,
        },
        */
        {
          label: Estados.NO_APROBADO,
        },
      ];
      break;
    case Estados.NO_PAGADO:
      list = [
        { label: Estados.PAGADO },
      ];
      break;
    default:
      list = [];
      break;
  }

  const handleClickOption = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOption = () => {
    setAnchorEl(null);
  };

  const openCambioEstado = (estadoNuevo) => {
    handleCloseOption();
    setConfirmModal(true);
    setEstado(estadoNuevo);
  };

  const closeCambioEstado = () => {
    setConfirmModal(false);
    setEstado('');
  };

  // eslint-disable-next-line consistent-return
  async function cambioEstado(formValues) {
    setIsWaiting(true);
    const url = `${endPoint}/${id || ''}`;
    const data = { estado, ...formValues };
    let resp = [];
    try {
      resp = await doPut({ url, data });
      closeCambioEstado();
      if (redirect) {
        history.push(redirectUrl);
      } else {
        refresh();
      }
      if (extraFunction) {
        extraFunction(resp);
      }
      if (getResp) {
        getResp(resp);
      } else {
        if (ownResponseCode) {
          return null;
        }
        appInfo(messages.crud.update);
      }
    } catch (e) {
      genericException(e);
    } finally {
      setIsWaiting(false);
    }
  }

  return (
    <>
      <ButtonEstados
        onClick={handleClickOption}
        disabled={disabled}
        style={{ marginLeft: isSmallView ? 0 : 10 }}
        {...rest}
      />
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseOption}
      >
        {specificList.length === 0
          ? list.map((item) => (
            <MenuItemBase
              onClick={() => (openOwnChangeModal
                ? openOwnChangeModal(item.label, handleCloseOption, id)
                : openCambioEstado(item.label))}
              label={item.label}
              key={item.label}
            />
          ))
          : specificList.map((item) => (
            <MenuItemBase
              onClick={() => (openOwnChangeModal
                ? openOwnChangeModal(item.label, handleCloseOption, id)
                : openCambioEstado(item.label))}
              label={item.label}
              key={item.label}
            />
          ))}
      </StyledMenu>
      { (confirmModal && !openOwnChangeModal) && (
        <FormComentario
          open={confirmModal}
          close={closeCambioEstado}
          onSubmit={cambioEstado}
          estado={estado}
          isWaiting={isWaiting}
        />
      )}
    </>
  );
}

EstadoSelection.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }),
  doPut: PropTypes.func,
  appInfo: PropTypes.func,
  generic: PropTypes.bool,
  appError: PropTypes.func,
  extraFunction: PropTypes.func,
  ownResponseCode: PropTypes.bool,
  openOwnChangeModal: PropTypes.func,
  // Estado en el que se encuentra el proceso
  estadoActual: PropTypes.string.isRequired,
  // Ruta a la cual se va a hacer la peticion del cambio
  endPoint: PropTypes.string.isRequired,
  // Id del proceso al que se le va a hacer el cambio
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Boolean si se requiere redireccionar despues del cambio de estado
  redirect: PropTypes.bool,
  // Dirreccion a la cual se va a redireccionar
  redirectUrl: PropTypes.string,
  // Funcion encargada de refrescar los datos, se usa cuando no se redirrecciona
  refresh: PropTypes.func,
  // Boolean encargado de habilitar o deshabilitar el botón
  disabled: PropTypes.bool,
  // Booleano que indica si el estado aplica o no
  noAprobado: PropTypes.bool,
  // Booleano que indica si el estado aplica o no
  noPublicado: PropTypes.bool,
  specificList: PropTypes.oneOfType([PropTypes.array]),
  checkAccess: PropTypes.func,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  // Funcion que debe ser enviada desde el componente para obtener la
  // respuesta y hacer algo con ella
  getResp: PropTypes.func,
  genericException: PropTypes.func,
  // Funcion para ejecutarse despues de hacer el cambio de estado
};

export default withApi(withNotification((EstadoSelection)));
